import { render, staticRenderFns } from "./RewardModal.vue?vue&type=template&id=0e968e04&scoped=true"
import script from "./RewardModal.vue?vue&type=script&lang=js"
export * from "./RewardModal.vue?vue&type=script&lang=js"
import style0 from "./RewardModal.vue?vue&type=style&index=0&id=0e968e04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e968e04",
  null
  
)

export default component.exports